"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-3c2c5274"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = ["data-id", "id"];
const _hoisted_2 = { class: "name-container align-center flex-gap" };
const _hoisted_3 = ["href"];
const _hoisted_4 = ["id", "data-date", "data-user"];
const _hoisted_5 = ["id"];
const _hoisted_6 = ["id"];
const _hoisted_7 = {
    key: 0,
    class: "zmdi zmdi-lock"
};
const _hoisted_8 = ["id"];
const _hoisted_9 = {
    key: 0,
    class: "zmdi zmdi-lock"
};
const _hoisted_10 = ["id"];
const _hoisted_11 = {
    key: 0,
    class: "zmdi zmdi-lock"
};
const _hoisted_12 = ["id"];
const _hoisted_13 = {
    key: 0,
    class: "zmdi zmdi-lock"
};
const vue_3 = require("vue");
const SummaryTableSpotworkerCell_vue_1 = __importDefault(require("./SummaryTableSpotworkerCell.vue"));
const provider_1 = require("../../../provider/provider");
exports.default = (0, vue_1.defineComponent)({
    __name: 'SummaryTableSpotworkerRow',
    props: {
        spotworker: {},
        spotShifts: {},
        dates: {},
        stats: {},
        showMemoSummary: { type: Boolean },
        showDataCells: { type: Boolean },
        isOpen: { type: Boolean },
        isLastRow: { type: Boolean },
        isTempRow: { type: Boolean }
    },
    emits: ["mounted", "selected-shift"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const meStore = (0, vue_3.inject)(provider_1.summaryTableMeStoreInjectKey);
        const rowEl = (0, vue_3.ref)(null);
        (0, vue_3.onMounted)(() => {
            if (rowEl.value) {
                emit("mounted", rowEl.value);
            }
        });
        function handleSelectedShift(shiftId) {
            emit("selected-shift", shiftId);
        }
        const rowKey = (0, vue_3.computed)(() => {
            if (props.isTempRow && props.spotworker.tempId)
                return props.spotworker.tempId;
            return String(props.spotworker.id);
        });
        const userId = (0, vue_3.computed)(() => props.spotworker.id);
        const name = (0, vue_3.computed)(() => props.spotworker.name);
        const userHref = (0, vue_3.computed)(() => {
            return `/dashboard/${meStore?.me.getId()}/spotworker?c=${meStore?.activeBranchId}`;
        });
        const roleCounts = (0, vue_3.computed)(() => props.stats?.roleCounts || []);
        const showStatsLock = (0, vue_3.computed)(() => props.stats?.showStatsLock ?? true);
        return (_ctx, _cache) => {
            return (_ctx.isOpen)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("tr", {
                    key: 0,
                    ref_key: "rowEl",
                    ref: rowEl,
                    class: (0, vue_2.normalizeClass)(["spotworker-summary-row summary-users-row user-row", { 'spotwork-bg': !_ctx.spotworker?.id }]),
                    "data-id": rowKey.value,
                    id: rowKey.value
                }, [
                    (0, vue_2.createElementVNode)("td", {
                        class: (0, vue_2.normalizeClass)(["name text-popup name-tag-container pb-0 pt-0", { 'spot-border': _ctx.isLastRow, 'spotwork-bg': !_ctx.spotworker?.id }])
                    }, [
                        (0, vue_2.createElementVNode)("div", _hoisted_2, [
                            (0, vue_2.createElementVNode)("a", {
                                class: (0, vue_2.normalizeClass)(["no-color user-link text-ellipsis", { 'text-gray': _ctx.isTempRow }]),
                                href: userHref.value
                            }, (0, vue_2.toDisplayString)(name.value), 11 /* TEXT, CLASS, PROPS */, _hoisted_3)
                        ])
                    ], 2 /* CLASS */),
                    (_ctx.showMemoSummary && _ctx.showDataCells)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", {
                            key: 0,
                            class: (0, vue_2.normalizeClass)([{ 'spot-border': _ctx.isLastRow }, "text-center memo-text"])
                        }, (0, vue_2.toDisplayString)(_ctx.spotworker.memo), 3 /* TEXT, CLASS */))
                        : (0, vue_2.createCommentVNode)("v-if", true),
                    (_ctx.showDataCells)
                        ? ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 1 }, (0, vue_2.renderList)(_ctx.dates, (date) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", {
                                id: `date-${rowKey.value}_${date}`,
                                key: date,
                                class: (0, vue_2.normalizeClass)(["list relative data-cell", { 'spot-border': _ctx.isLastRow }]),
                                "data-date": date,
                                "data-user": rowKey.value
                            }, [
                                (0, vue_2.createVNode)(SummaryTableSpotworkerCell_vue_1.default, {
                                    "spot-shifts": _ctx.spotShifts?.[date],
                                    onSelectedShift: handleSelectedShift
                                }, null, 8 /* PROPS */, ["spot-shifts"])
                            ], 10 /* CLASS, PROPS */, _hoisted_4));
                        }), 128 /* KEYED_FRAGMENT */))
                        : (0, vue_2.createCommentVNode)("v-if", true),
                    (0, vue_2.createCommentVNode)(" Currently, these cells act as placeholders for document selectors in other files. Must provide exact id. "),
                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(roleCounts.value, (roleCount) => {
                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", {
                            id: `role-count-${roleCount.id}-${rowKey.value}-count`,
                            key: roleCount.id,
                            class: (0, vue_2.normalizeClass)(["bg-gray text-center", { 'd-none': !_ctx.showDataCells, 'spot-border': _ctx.isLastRow }])
                        }, " - ", 10 /* CLASS, PROPS */, _hoisted_5));
                    }), 128 /* KEYED_FRAGMENT */)),
                    (_ctx.stats?.showEmployeeWorkCountCell)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", {
                            key: 2,
                            id: showStatsLock.value ? '' : `work-count-${userId.value}`,
                            class: (0, vue_2.normalizeClass)(["bg-gray text-center", { 'spot-border': _ctx.isLastRow, 'd-none': !_ctx.showDataCells }])
                        }, [
                            (showStatsLock.value)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_7))
                                : (0, vue_2.createCommentVNode)("v-if", true)
                        ], 10 /* CLASS, PROPS */, _hoisted_6))
                        : (0, vue_2.createCommentVNode)("v-if", true),
                    (_ctx.stats?.showEmployeeVacationCountCell)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", {
                            key: 3,
                            id: showStatsLock.value ? '' : `vacation-count-${userId.value}`,
                            class: (0, vue_2.normalizeClass)(["bg-gray text-center", { 'spot-border': _ctx.isLastRow, 'd-none': !_ctx.showDataCells }])
                        }, [
                            (showStatsLock.value)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_9))
                                : (0, vue_2.createCommentVNode)("v-if", true)
                        ], 10 /* CLASS, PROPS */, _hoisted_8))
                        : (0, vue_2.createCommentVNode)("v-if", true),
                    (_ctx.stats?.showEmployeePTOCountCell)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", {
                            key: 4,
                            id: showStatsLock.value ? '' : `pto-count-${userId.value}`,
                            class: (0, vue_2.normalizeClass)(["bg-gray text-center", { 'spot-border': _ctx.isLastRow, 'd-none': !_ctx.showDataCells }])
                        }, [
                            (showStatsLock.value)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_11))
                                : (0, vue_2.createCommentVNode)("v-if", true)
                        ], 10 /* CLASS, PROPS */, _hoisted_10))
                        : (0, vue_2.createCommentVNode)("v-if", true),
                    (_ctx.stats?.showEmployeeLaborCountCell)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", {
                            key: 5,
                            id: showStatsLock.value ? '' : `labor-hours-${userId.value}`,
                            class: (0, vue_2.normalizeClass)(["bg-gray text-center", { 'spot-border': _ctx.isLastRow, 'd-none': !_ctx.showDataCells }])
                        }, [
                            (showStatsLock.value)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_13))
                                : (0, vue_2.createCommentVNode)("v-if", true)
                        ], 10 /* CLASS, PROPS */, _hoisted_12))
                        : (0, vue_2.createCommentVNode)("v-if", true)
                ], 10 /* CLASS, PROPS */, _hoisted_1))
                : (0, vue_2.createCommentVNode)("v-if", true);
        };
    }
});
